"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ZIndexLayers;

(function (ZIndexLayers) {
  ZIndexLayers[ZIndexLayers["BASE"] = 1] = "BASE";
  ZIndexLayers[ZIndexLayers["TRANSPARENT_NATIVE_SELECT"] = 2] = "TRANSPARENT_NATIVE_SELECT";
  ZIndexLayers[ZIndexLayers["HOVER"] = 3] = "HOVER";
  ZIndexLayers[ZIndexLayers["FOCUS"] = 4] = "FOCUS";
  ZIndexLayers[ZIndexLayers["DROPDOWN_MENU"] = 5] = "DROPDOWN_MENU";
})(ZIndexLayers || (ZIndexLayers = {}));

exports.default = ZIndexLayers;